import type { ReactNode } from 'react';
import React, { useState } from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import type { OnboardingState } from './onboardingReducer';
import { OnboardingCheckBox } from './SharedUI';

const TERMS_URL = 'https://fragment.dev/legal';

type SectionProps = {
  title: string;
  part1: ReactNode;
  part2: ReactNode;
};

const Section = ({ title, part1, part2 }: SectionProps) => (
  <div className="flex flex-col gap-y-f4">
    <span className="text-negative text-md bg-main text-center">{title}</span>
    <div className="text-main text-md">{part1}</div>
    <div className="text-main text-md">{part2}</div>
  </div>
);

type NoticeViewProps = {
  onboardingState: OnboardingState;
  setOnboardingField: (
    stateKey: string,
    value: string | string[] | boolean | { type: string; number: string }[]
  ) => void;
  onNext?: () => void;
};

export const NoticeView = ({
  onboardingState,
  setOnboardingField,
  onNext,
}: NoticeViewProps) => {
  const { termsAgreedAt } = onboardingState;
  const [checked, setChecked] = useState<boolean>(
    termsAgreedAt != null && termsAgreedAt.length > 0
  );

  const handleTermsClick = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    setOnboardingField(
      'termsAgreedAt',
      newChecked ? new Date().toISOString() : ''
    );
    setOnboardingField('termsUrl', newChecked ? TERMS_URL : '');
  };

  return (
    <div className="flex flex-col gap-y-f4 h-fit max-h-full">
      <div className="flex flex-col flex-1 min-h-0 gap-y-f4 overflow-y-scroll">
        <Section
          title="Important Information About Procedures for Opening a New Account"
          part1={
            <span>
              {`To help the government fight the funding of terrorism and money
          laundering activities, Federal law requires all financial institutions
          to obtain, verify, and record information that identifies each person
          who opens an account.`}
            </span>
          }
          part2={
            <span>
              {`What this means for you: When you open an account, we will ask for
            your name, address, date of birth, and other information that will
            allow us to identify you. If further verification is required, we may
            also ask to see your driver's license or other identifying documents.`}
            </span>
          }
        />
      </div>
      <OnboardingCheckBox
        checked={checked}
        label={
          <span className="text-md">
            I have read and agree to the{' '}
            <a
              href={TERMS_URL}
              className="text-main hover:text-main transition-colors underline decoration-main-500 hover:decoration-main"
            >
              terms of use and privacy policy
            </a>
            .
          </span>
        }
        onClick={handleTermsClick}
      />
      {onNext != null && (
        <PrimaryButtonV2 onClick={onNext}>Next</PrimaryButtonV2>
      )}
    </div>
  );
};
